import React from 'react';
import classnames from 'classnames';

import ubBanzai from 'ub/control/banzai-features';
import ModalNote from '../modal-note';

import styles from './convertable-mobile-tour.scss';

export default function ConvertableMobileTour(props) {
  const { displayNameCapitalized, displayNameLowerCase, showOverlaySEOWarning } = props;

  const isNewBreakpointToggleEnabled = ubBanzai.features.isNewBreakpointToggleEnabled();
  const imageClassName = classnames(styles.image, 'convertable-mobile-tour-img', {
    new: isNewBreakpointToggleEnabled,
  });

  return (
    <div>
      <section className={styles.content}>
        <div className={styles.copy}>
          {
            isNewBreakpointToggleEnabled ? (
              <div className={styles.copytext}>
                Make sure the{' '}
                <span className={styles.strong}>Mobile</span>{' '}
                toggle is enabled (in the bottom-right), otherwise this {displayNameLowerCase} won&apos;t
                display to visitors on phones.
              </div>
            ) : (
              <div className={styles.copytext}>
                Make sure
                <span className={styles.strong}>Show Mobile Version to Visitors</span>
                from the {displayNameCapitalized} Properties tab is checked (on the right),
                otherwise this {displayNameLowerCase} won&apos;t display to visitors on phones.
              </div>
            )
          }

          <div className={styles.copytext}>
            Once enabled, save your changes then publish or republish it and you&apos;e good to go.
          </div>
        </div>
        <div className={imageClassName} />
      </section>

      {
        showOverlaySEOWarning &&
          <ModalNote>
            <div className={styles.notice}>
              <span className={styles.highlight}>Did you know?</span>{' '}
              Some settings for {displayNameLowerCase}s do not work well on mobile devices.
              <br />
              Be sure to check out{' '}
              <a
                href='http://documentation.unbounce.com/hc/en-us/articles/115001543066'
                target='_blank'
                rel="noopener noreferrer"
                className={styles.link}
              >
                our recommendations.
              </a>
            </div>
          </ModalNote>
      }
    </div>
  );
}

ConvertableMobileTour.propTypes = {
  displayNameCapitalized: React.PropTypes.string,
  displayNameLowerCase: React.PropTypes.string,
  showOverlaySEOWarning: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/mobile-tour/convertable-mobile-tour.jsx